import { Injectable, Provider } from '@angular/core';
import { OrderClient, OrderGetQuery, OrderGetQueryResult, OrderListGetQuery, OrderListGetQueryResult, PreOrderListGetQuery, PreOrderListGetQueryResult } from '../../INTEGRA_Shop_Client';
import { firstValueFrom } from 'rxjs';
import { IOrderApiService, IOrderApiServiceToken } from './order-api-service.interface';
import { BasicError } from 'projects/shared/lib/error/basic-error';

@Injectable({
  providedIn: 'root'
})
export class OrderApiService implements IOrderApiService {

  constructor(
    private orderClient: OrderClient,
  ) { }

  public async orderListGetAsync(loadReferences: boolean, orderDateMinimum: Date | undefined): Promise<OrderListGetQueryResult> {
    let query = new OrderListGetQuery({
      loadReferences: loadReferences,
      orderDateMinimum: orderDateMinimum
    });

    return await firstValueFrom(this.orderClient.orderListGet(query));
  }

  public async orderGetByDidAsync(integraBelegDid: string | undefined): Promise<OrderGetQueryResult> {
    let hasIntegraDid: boolean = integraBelegDid != undefined && integraBelegDid.length > 0;

    if (hasIntegraDid == false) {
      // ToDo: decide whether we should throw an exception... OR get an empty result...
      throw new BasicError("Missing query parameter in orderGetByDidAsync");
      // return new OrderGetQueryResult();
    }

    let query = new OrderGetQuery({
      integraBelegDid: integraBelegDid
    });

    return await firstValueFrom(this.orderClient.orderGet(query));
  }

  public async orderGetByNrAsync(webshopOrderNumber: string | undefined, integraOrderNumber: string | undefined): Promise<OrderGetQueryResult> {
    let hasWebNumber: boolean = webshopOrderNumber != undefined && webshopOrderNumber.length > 0;
    let hasIntegraNumber: boolean = integraOrderNumber != undefined && integraOrderNumber.length > 0;

    if (hasWebNumber == false && hasIntegraNumber == false) {
      // ToDo: decide whether we should throw an exception... OR get an empty result...
      throw new BasicError("Missing query parameter in orderGetByNrAsync");
      // return new OrderGetQueryResult();
    }

    let query = new OrderGetQuery();

    if (hasWebNumber) {
      query.webshopOrderNumber = webshopOrderNumber;
    }

    if (hasIntegraNumber) {
      query.integraOrderNumber = integraOrderNumber;
    }

    return await firstValueFrom(this.orderClient.orderGet(query));
  }

  public async preOrderListGetAsync(): Promise<PreOrderListGetQueryResult> {
    let query = new PreOrderListGetQuery();

    return await firstValueFrom(this.orderClient.preOrderListGet(query));
  }

}

/**
 * Prepared provider with the token to implementation mapping.
 * Reference this at the desired provider list to enable the injection of this implementation by referencing the token(interface).
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const OrderApiServiceProvider: Provider[] = [
  { provide: OrderClient },
  { provide: IOrderApiServiceToken, useExisting: OrderApiService }
];
